<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col sm="6">
                    <EngagementNav></EngagementNav>
                </b-col>
                <b-col sm="6" md="3" style="background-color: #ffffff">
                    <div id="sms-wrapper" class="py-2 px-3 ml-auto">
                        <b-row no-gutters>
                            <b-col cols="5">
                                <div style="margin-left: 1px; margin-top: 5px;">
                                    <img src="@/assets/images/icons/sms.svg" alt="SMS Icon" class="mr-2">
                                    <span style="font-family: MainFontRegular, sans-serif;
                                                font-size: 16px;
                                                color: #2A2A2A;
                                                vertical-align: middle;">SMS Sent</span>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="d-inline-block">
                                    <div id="sms">
                                        <b-form-input :value="sms"
                                                      disabled
                                                      type="text"
                                                      class="muli-b text-center">
                                        </b-form-input>
                                    </div>
                                </div>
                                <i id="sms-help" class="d-inline-block"></i>
                                <b-popover target="sms-help"
                                           placement="bottomleft"
                                           triggers="hover"
                                           content="This is the total number of SMS messages sent to all registered customers.">
                                </b-popover>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col sm="6" md="3" style="background-color: #ffffff;">
                    <div id="monthly-sms-wrapper" class="py-2 px-3 ml-auto">
                        <b-row no-gutters>
                            <b-col cols="6">
                                <div style="margin-left: 1px; margin-top: 5px;">
                                    <img src="@/assets/images/icons/sms.svg" alt="SMS Icon" class="mr-2">
                                    <span style="font-family: MainFontRegular, sans-serif;
                                                font-size: 16px;
                                                color: #2A2A2A;
                                                vertical-align: middle;">Monthly SMS</span>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="d-inline-block">
                                    <div id="sms">
                                        <b-form-input :value="monthlySms"
                                                      disabled
                                                      type="text"
                                                      class="muli-b text-center">
                                        </b-form-input>
                                    </div>
                                </div>
                                <i id="sms-help" class="d-inline-block"></i>
                                <b-popover target="sms-help"
                                           placement="bottomleft"
                                           triggers="hover"
                                           content="This is the total number of SMS messages sent to all registered customers.">
                                </b-popover>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div>
            <div class="engagement-body">
                <div class="engagement-content">
                    <b-row>
                        <b-col v-for="statistic in statistics"  :key="statistic.display" sm="6" md="3" class="mb-5">
                            <stat-card 
                                :icon="statistic.icon"
                                :note="statistic.note"
                                :value="statistic.value" 
                                :title="statistic.display" 
                                :icon-bg-color="statistic.iconBgColor"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3" md="2">
                            <div class="filter-wrapper">
                                <b-form-select v-model="selectedBroadcast"
                                               :options="broadcastOptions"/>
                            </div>
                        </b-col>
                        <b-col sm="6" md="3">
                            <b-input-group>
                                <b-input-group slot="append">
                                    <i class="icon-calendar" style="cursor: pointer" data-toggle @click="openRangePicker"></i>
                                    <i class="icon-clear" style="cursor: pointer" data-toggle @click="clearRangePicker"></i>
                                </b-input-group>
                                <datepicker
                                        ref="rangePicker"
                                        v-model="dateRange"
                                        :config="dateRangeConfig"
                                        class="form-control"
                                        placeholder="Select Date Range"
                                        name="date">
                                </datepicker>
                            </b-input-group>

                        </b-col>
                        <b-col sm="6" md="3">
                            <div class="filter-wrapper">
                                <b-input-group prepend=" ">
                                    <b-form-input placeholder="Search"
                                                  @keydown.enter.native="search()"
                                                  v-model="searchString">
                                    </b-form-input>
                                    <b-dropdown text="Advanced" variant="primary" slot="append">
                                        <!--Uncomment this part to enable multiple select of search options-->
                                        <!--<div class="ml-3 p-1 mt-1" id="search-checkbox">
                                            <b-form-checkbox-group
                                                    stacked
                                                    v-model="selectedSearchOption"
                                                    name="searchOptions"
                                                    :options="searchableFields" class="checkbox-group">
                                            </b-form-checkbox-group>
                                        </div>
                                        <b-dropdown-divider style="margin-top: -5px"></b-dropdown-divider>
                                        <div class="search-btn-wrapper">
                                            <b-button class="search-btn mr-1" size="sm" @click="clearSearch" variant="secondary">Clear</b-button>
                                            <b-button class="search-btn" size="sm" @click="search" variant="primary">Search</b-button>
                                        </div>-->
                                        <!--End Multiple Select-->

                                        <!--Begin Single Select-->

                                        <b-dropdown-item v-for="searchField in searchableFields"
                                                         :key="searchField.value"
                                                         @click="searchOption(searchField.value)">
                                            {{ searchField.text }}
                                            <i v-if="selectedSearchOption.indexOf(searchField.value) !== -1" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                            </i>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group>
                            </div>
                        </b-col>
                        <b-col sm="4" md="4" class="text-md-right text-left">
                            <b-button variant="primary" class="new-button" @click="$router.push({ name: 'broadcastingDesign', params: { type: 'sms' } });">
                                + Create Broadcast
                            </b-button>
                            <!-- @click="newBroadcast('send-new-broadcast')"  -->
                            <b-modal no-close-on-backdrop id="send-new-broadcast" size="lg" :title="title" body-class="text-left">
                                <div v-if="initializing && !creating" style="text-align: center">Please wait...</div>
                                <div v-else class="modal-form">
                                    <b-row no-gutters>
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">Title</h6>
                                        </b-col>
                                        <b-col>
                                            <b-form-group id="broadcastTitleGroup"
                                                          label=" Broadcast Title"
                                                          label-for="broadcastTitle"
                                                          class="secondary-label"
                                                          :invalid-feedback="errorMessage('title')"
                                                          :state="isValid('title')">
                                                <b-form-input id="broadcastTitle"
                                                              type="text"
                                                              v-model="form.broadcastTitle"
                                                              maxlength="50"
                                                              required>
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col>
                                            <hr class="form-divider">
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">Audience</h6>
                                        </b-col>
                                        <b-col>
                                            <b-form-group id="audienceGroup"
                                                          label="Audience"
                                                          label-for="audience"
                                                          class="secondary-label"
                                                          :invalid-feedback="errorMessage('target_segment_uuid')"
                                                          :state="isValid('target_segment_uuid')">
                                                <b-form-select v-model="form.selectedAudience" :options="form.audienceOptions" class="mb-3 muli-sb" />
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col>
                                            <hr class="form-divider">
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">SMS<i id="sms-label-help" class="help d-inline-block"></i></h6>
                                            <b-popover target="sms-label-help"
                                                       triggers="hover"
                                                       content="Send a quick text message to your registered customers (160 characters including spaces).">
                                            </b-popover>
                                            <switches
                                                    v-model="form.smsEnabled"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    text-enabled="On"
                                                    text-disabled="Off"
                                            >
                                            </switches>
                                        </b-col>
                                        <b-col>
                                            <b-form-group id="smsDescriptionGroup"
                                                          :label="'SMS Count: ' + smsCounterLabel"
                                                          label-for="smsDescription"
                                                          :invalid-feedback="errorMessage('sms_message')"
                                                          :state="isValid('sms_message')"
                                                          class="secondary-label mb-2"
                                                          v-bind:class="{ 'disabled-label': !form.smsEnabled }">
                                                <b-form-textarea id="smsDescription"
                                                                 v-model="form.smsDescription"
                                                                 placeholder="Enter description"
                                                                 :rows="4"
                                                                 :max-rows="6"
                                                                 :disabled="!form.smsEnabled">
                                                </b-form-textarea>
                                            </b-form-group>
                                            <label class="secondary-label mb-0" v-bind:class="{ 'disabled-label': !form.smsEnabled }">Character Count: {{ smsDescriptionLabel }}</label>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col>
                                            <hr class="form-divider">
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters v-if="planId != 1 && planId != 2">
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">Push Notif<i id="push-notif-label-help" class="help d-inline-block"></i></h6>
                                            <b-popover target="push-notif-label-help"
                                                       triggers="hover"
                                                       content="Send mobile alerts to your customers who have installed the customer application.">
                                            </b-popover>
                                            <switches
                                                    v-model="form.pushNotifEnabled"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    text-enabled="On"
                                                    text-disabled="Off"
                                            >
                                            </switches>
                                        </b-col>
                                        <b-col>
                                            <b-form-group id="campaignNameGroup"
                                                          label="Campaign Name"
                                                          :invalid-feedback="errorMessage('push_campaign_name')"
                                                          :state="isValid('push_campaign_name')"
                                                          label-for="campaignName" class="secondary-label">
                                                <b-form-input id="campaignName"
                                                              :disabled="!form.pushNotifEnabled"
                                                              type="text"
                                                              v-model="form.campaignName"
                                                              maxlength="25"
                                                              required>
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group id="pushNotifGroup"
                                                          :invalid-feedback="errorMessage('push_message')"
                                                          :state="isValid('push_message')"
                                                          :label="pushDescriptionLabel"
                                                          label-for="pushNotifDescription" class="secondary-label" v-bind:class="{ 'disabled-label': !form.pushNotifEnabled }">
                                                <b-form-textarea id="pushNotifDescription"
                                                                 v-model="form.pushNotifDescription"
                                                                 placeholder="Enter description"
                                                                 :rows="4"
                                                                 :max-rows="6"
                                                                 :maxlength="form.maxPushNotifDescription"
                                                                 :disabled="!form.pushNotifEnabled">
                                                </b-form-textarea>
                                            </b-form-group>
                                            <b-form-group label="Device Type"
                                                          :invalid-feedback="errorMessage('has_device')"
                                                          :state="isValid('has_device')"
                                                          class="secondary-label pt-1"
                                                          style="margin-top: 28px; margin-bottom: 10px;">
                                                <b-form-checkbox-group id="deviceTypeGroup" name="deviceType" v-model="form.selectedDeviceType">
                                                    <b-form-checkbox :disabled="!form.pushNotifEnabled" value="android">Android</b-form-checkbox>
                                                    <b-form-checkbox :disabled="!form.pushNotifEnabled" value="ios" class="ml-4">iOS</b-form-checkbox>
                                                </b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2" v-if="planId != 1 && planId != 2">
                                        <b-col>
                                            <hr class="form-divider">
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters v-if="planId != 1">
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">Email<i id="email-label-help" class="help d-inline-block"></i></h6>
                                            <b-popover target="email-label-help"
                                                       triggers="hover"
                                                       content="Send an electronic mail to your registered customers.">
                                            </b-popover>
                                            <switches
                                                    v-model="form.emailEnabled"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    text-enabled="On"
                                                    text-disabled="Off"
                                            >
                                            </switches>
                                        </b-col>
                                        <b-col>
                                            <b-form-group id="subjectGroup"
                                                          label="Subject"
                                                          :invalid-feedback="errorMessage('email_subject')"
                                                          :state="isValid('email_subject')"
                                                          label-for="subject" class="secondary-label">
                                                <b-form-input id="subject"
                                                              type="text"
                                                              v-model="form.subject"
                                                              maxlength="50"
                                                              :disabled="!form.emailEnabled"
                                                              required>
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group id="messageGroup"
                                                          label="Message"
                                                          :invalid-feedback="errorMessage('email_message')"
                                                          :state="isValid('email_message')"
                                                          label-for="message" class="secondary-label">
                                                <vue-editor :disabled="!form.emailEnabled" id="message" v-model="form.message" required :editorToolbar="customToolbar"></vue-editor>
                                            </b-form-group>
                                            <b-form-group
                                                          :invalid-feedback="errorMessage('has_broadcast')"
                                                          :state="isValid('has_broadcast')"
                                                          label-for="message" class="secondary-label">
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2" v-if="planId != 1">
                                        <b-col>
                                            <hr class="form-divider">
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">Schedule<i id="schedule-label-help" class="help d-inline-block"></i></h6>
                                            <b-popover target="schedule-label-help"
                                                    triggers="hover"
                                                    content="Set the date and time when the message will be sent to your registered customers.">
                                            </b-popover>
                                        </b-col>
                                        <b-col>
                                            <b-row no-gutters>
                                                <b-col cols="5">
                                                    <b-form-group class="mb-1 secondary-label"
                                                                  :invalid-feedback="errorMessage('scheduled_time')"
                                                                  :state="isValid('scheduled_time')">
                                                        <label class="secondary-label align-top">Date</label>
                                                        <div class="custom-datepicker mb-3 muli-sb">
                                                            <SingleDatepicker :bootstrap-styling="true"
                                                                              :value="form.scheduledDate"
                                                                              ref="programaticOpen"
                                                                              v-model="form.scheduledDate"
                                                                              wrapper-class="custom-datepicker"
                                                                              style="color: #2a2a2a !important;"
                                                            >
                                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                                    <span class="input-group-text">
                                                                        <img @click="openPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                                    </span>
                                                                </div>
                                                            </SingleDatepicker>
                                                        </div>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols>
                                                    <div id="custom-timepicker" style="width: 164px;">
                                                        <b-form-group class="ml-3">
                                                            <label class="secondary-label align-top">Time</label>
                                                            <b-input-group>
                                                                <b-input-group-text slot="append">
                                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                                </b-input-group-text>
                                                                <vue-timepicker v-model="form.scheduledTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-2">
                                        <b-col>
                                            <hr class="form-divider">
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="12" md="3">
                                            <h6 class="main-label">Visibility<i id="visibility-label-help" class="help d-inline-block"></i></h6>
                                            <b-popover target="visibility-label-help"
                                                       triggers="hover"
                                                       content="Toggle to allow/disallow publishing of the message in your customer application.">
                                            </b-popover>
                                        </b-col>
                                        <b-col>
                                            <div>
                                                <span class="d-block mb-3 secondary-label">Publish in App</span>
                                                <switches v-model="form.broadcastVisibility"
                                                          theme="custom"
                                                          color="primary"
                                                          type-bold="true"
                                                          text-enabled="On"
                                                          text-disabled="Off"
                                                          style="top: -18px;">
                                                </switches>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div v-show="!initializing || creating" slot="modal-footer">
                                    <b-btn :disabled="loading" variant="ghost" @click="handleCancel('send-new-broadcast')" class="mr-1 btn-cancel">
                                        Cancel
                                    </b-btn>
                                    <b-btn :disabled="loading" variant="primary" @click="handleSave('send-new-broadcast')" class="ml-1">
                                        Save
                                    </b-btn>
                                </div>
                            </b-modal>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="data-container">
                                <b-table :items="broadcasts"
                                         :fields="fields"
                                         :current-page="currentPage"
                                         show-empty
                                         responsive
                                         empty-text="No Records Found"
                                >
                                    <template slot="type" slot-scope="data">
                                        <span style="text-transform: capitalize"> {{ getTypes(data.value)}}</span>
                                    </template>
                                    <template slot="published" slot-scope="data">
                                        <div class="d-inline-block py-1 px-2 text-center mr-1" :class="{ published: data.value, scheduled: !data.value }">
                                            {{ data.value === 1 ? 'Published' : 'Scheduled ' }}
                                        </div>
                                        {{ formatDate(broadcasts[data.index].scheduled_time) }}
                                    </template>
                                    <template slot="created_at" slot-scope="data">
                                        <span>
                                            {{ formatDate(data.value) }}
                                        </span>
                                    </template>
                                    <template slot="failed_push_notif" slot-scope="data">
                                        <template v-if="data.item.published === 0">
                                            0
                                        </template>
                                        <template v-else>
                                            {{ data.value == null ? "..." : data.value }}
                                        </template>
                                    </template>
                                    <template slot="successful_push_notif" slot-scope="data">
                                        <template v-if="data.item.published === 0">
                                            0
                                        </template>
                                        <template v-else>
                                            {{ data.value == null ? "..." : data.value }}
                                        </template>
                                    </template>
                                    <template slot="successful_sms" slot-scope="data">
                                        {{ data.value == null ? "..." : data.value }}
                                    </template>
                                    <template slot="failed_sms" slot-scope="data">
                                        {{ data.value == null ? "..." : data.value }}
                                    </template>
                                    <template slot="uuid" slot-scope="data">
                                        <b-row no-gutters>
                                            <b-col class="text-center" v-if="data.item.published !== 1">
                                                <img src="../../assets/images/actions/edit.svg" alt="Edit Button"
                                                     class="action-button"
                                                     @click="$router.push({ name: 'broadcastingDesign', params: { uuid: data.value } })"
                                                     >
                                                     <!-- @click="editBroadcast('send-new-broadcast', data.value)" -->
                                                <b-modal :id="'edit-modal' + data.value" title="Edit Modal">
                                                    <p class="my-4">Edit Modal</p>
                                                </b-modal>
                                            </b-col>
                                            <b-col class="text-center">
                                                <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button" @click="showModal('delete-modal' + data.index)">
                                                <b-modal :id="'delete-modal' + data.index" title="Confirm Delete">
                                                    <p class="modal-main-message">Are you sure you want delete this item:</p>
                                                    <h3 class="modal-secondary-message">{{ broadcasts[data.index].title }}</h3>
                                                    <div slot="modal-footer">
                                                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal' + data.index)">
                                                            Cancel
                                                        </b-btn>
                                                        <b-btn variant="primary" class="ml-1" @click="handleDelete('delete-modal' + data.index, data.value)">
                                                            Yes, Delete
                                                        </b-btn>
                                                        <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
                                                    </div>
                                                </b-modal>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-table>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="mt-1">
                                <!--<span class="pagination-indicator">Showing 1 to {{ totalRows - 1 }} of 100 per page</span>-->
                                <span class="pagination-indicator">{{ currentFirstItem }}-{{ currentLastItem }} of {{ maxPage }} page</span>
                            <b-pagination
                                hide-goto-end-buttons
                                align="left" size="md"
                                :limit="3"
                                @change="getBroadcasts"
                                :value="currentPage"
                                :total-rows="maxPage * broadcasts.length"
                                :per-page="broadcasts.length"
                                class="custom-pagination-arrow-only mb-0 ml-2">
                            </b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import EngagementNav from "./EngagementNav.vue";
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";
import _ from "lodash";
import Switches from "vue-switches";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { VueEditor } from "vue2-editor";
import broadcastingFormInit from "../../services/engangemen.broadcasting.form.init";
import StatCard from "@/components/common/StatCard.vue";

const FIRST_PAGE = 1;
const SMS = "sms";
const PUSH = "push";
const EMAIL = "email";

export default {
    name: "engagement",
    data() {
        return {
            broadcastOptions: [{ value: "all", text: "All Broadcasts" }],
            selectedBroadcast: "all",
            dateRange: null,
            rangePicker: null,
            fields: [
                {
                    key: "reference_number",
                    label: "Reference No.",
                    sortable: true
                },
                { key: "title", sortable: true, label: "Broadcast Title" },
                { key: "type", sortable: true },
                { key: "successful_push_notif", sortable: true },
                { key: "failed_push_notif", sortable: true },
                { key: "successful_sms", sortable: true, label: "Successful SMS" },
                { key: "failed_sms", sortable: true, label: "Failed SMS" },
                { key: "published", sortable: true, label: "Status" },
                { key: "created_at", sortable: true, label: "Date Created" },
                { key: "uuid", label: "Action" }
            ],
            title: "",
            selectedSearchOption: [],
            searchString: "",
            searchPayload: null,
            booleanOptions: ["published", "visibility"],
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }]
            ],
            smsMaxCharacter: 160,
            smsCount: 1,
            env: process.env.VUE_APP_MODE
        };
    },
    components: {
        EngagementNav,
        Datepicker,
        Switches,
        VueEditor,
        SingleDatepicker,
        VueTimepicker,
        StatCard
    },
    computed: {
        ...mapState("engagementBroadcasting", [
            "broadcasts",
            "currentPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "searchableFields",
            "defaultSelectedSearchOption",
            "errors",
            "creating",
            "initializing",
            "loading",
            "form",
            "sms",
            "monthlySms",
            "short_code",
            "summaryCount",
            "currentFirstItem",
            "currentLastItem"
        ]),
        ...mapState("auth", ["planId", "unavailableToPlan"]),
        dateRangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    defaultDate: null,
                    onChange: function(selectedDates, dateStr) {
                        if (_.includes(dateStr, "to")) {
                            _this.search();
                        }
                    },
                    onReady: function(selectedDates, dateStr, instance) {
                        _this.rangePicker = instance;
                    }
                };
            }
        },
        smsDescriptionLabel: {
            get: function() {
                if (this.form.smsDescription != null) {
                    return (
                        this.form.smsDescription.length
                    );
                }
                return "0";
            }
        },
        smsCounterLabel: {
            get: function() {
                if (this.form.smsDescription != null) {
                    if (this.form.smsDescription.length > this.smsMaxCharacter) {
                        this.smsCount = this.smsCount + 1;
                        this.smsMaxCharacter = 160 * this.smsCount;
                        return this.smsCount.toString();
                    } else {
                        if (this.smsCount > 1) {
                            let prev = 160 * (this.smsCount - 1);
                            if (this.form.smsDescription.length <= prev) {
                                this.smsCount = this.smsCount - 1;
                                this.smsMaxCharacter = 160 * this.smsCount;
                                return this.smsCount.toString();
                            }
                        }
                        return this.smsCount.toString();
                    }
                }
            }
        },
        pushDescriptionLabel: {
            get: function() {
                if (this.form.pushNotifDescription != null) {
                    return (
                        this.form.pushNotifDescription.length +
                        " / " +
                        this.form.maxPushNotifDescription
                    );
                }
                return "0 / " + this.form.maxPushNotifDescription;
            }
        },
        statistics() {
            const month = this.summaryCount.month
                ? this.summaryCount.month
                : new Date().toLocaleString("default", {
                      month: "long"
                  });

            const note = this.summaryCount.created_at ?
                `Data as of ${this.$moment(this.summaryCount.created_at).format('YYYY/MM/DD, hh:mm a')}. For latest reading, we advise checking again on the next hour.` : 
                '';

            return [
                {
                    note,
                    display: `${month} Broadcast SMS Sent`,
                    value: 'monthly_count' in this.summaryCount
                        ? this.summaryCount.monthly_count
                        : "-",
                    iconBgColor: "rgba(81, 130, 255, 0.08)",
                    icon: 'monthly_sms_count.svg',                },
            ];
        }
    },
    async created() {
        this.getBroadcasts(FIRST_PAGE);
        this.getSearchOptions();
        this.getTargetSegmentOptions();
        this.initForm();
        this.getSmsCount();
        this.getMonthlySmsCount();
        this.$store.dispatch("engagementBroadcasting/getSummaryCount");
    },
    methods: {
        initForm() {
            let _form = broadcastingFormInit.formInit();
            this.$store.dispatch("engagementBroadcasting/resetForm", _form);
        },
        getSmsCount() {
            this.$store.dispatch("engagementBroadcasting/smsCount");
        },
        getMonthlySmsCount() {
            this.$store.dispatch("engagementBroadcasting/monthlySmsCount");
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);
        },
        getBroadcasts(page) {
            let param = {
                page: page,
                payload: {
                    search: this.searchPayload
                }
            };

            this.$store.dispatch("engagementBroadcasting/getBroadcasts", param);
        },
        clearSearch() {
            this.selectedSearchOption = [];
            this.search();
        },
        search() {
            let searchPayload = [];
            let _this = this;
            if (
                this.selectedSearchOption.length === 0 &&
                this.searchString.trim() !== ""
            ) {
                this.selectedSearchOption.push(
                    this.defaultSelectedSearchOption
                );
            }
            //Filter the selected search option
            _.forEach(_this.selectedSearchOption, function(field) {
                let obj = {};
                if (_this.booleanOptions.indexOf(field) !== -1) {
                    obj[field] = true;
                } else {
                    obj[field] = _this.searchString.trim();
                }
                searchPayload.push(obj);
            });
            //Include date range picker to selected search option
            if (this.dateRange != null) {
                let range = { created_at: this.dateRange };
                searchPayload.push(range);
            }
            //Save all the selected search option
            this.searchPayload = searchPayload;
            //Get the first page of the list
            this.getBroadcasts(FIRST_PAGE);
        },
        async getSearchOptions() {
            await this.$store.dispatch(
                "engagementBroadcasting/getSearchableFields"
            );
        },
        formatDate(date) {
            return this.$moment(date, "YYYY-MM-DD hh:mm:ss").format(
                "MMM D YYYY, h:mm a"
            );
        },
        getTypes(types) {
            let t = JSON.parse(types);
            return _.map(t).join(", ");
        },
        openRangePicker() {
            if (this.rangePicker != null) {
                this.rangePicker.toggle();
            }
        },
        clearRangePicker() {
            if (this.rangePicker === null) {
                return false;
            }
            this.rangePicker.clear();
            if (this.dateRange !== null) {
                this.dateRange = null;
                this.search();
            }
        },
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        handleDelete(modal, uuid) {
            this.hideModal(modal);
            this.$store.dispatch("engagementBroadcasting/delete", uuid);
        },
        handleCancel(modal) {
            this.hideModal(modal);
        },
        handleSave(modal) {
            let _date = this.$moment(
                this.form.scheduledDate,
                "ddd MMM DD YYYY"
            ).format("YYYY-MM-DD");
            let _time =
                this.form.scheduledTime.HH +
                ":" +
                this.form.scheduledTime.mm +
                ":" +
                this.form.scheduledTime.ss;
            let hasAndroid = this.isExist(
                this.form.selectedDeviceType,
                "android"
            );
            let hasIos = this.isExist(this.form.selectedDeviceType, "ios");
            let data = {
                title: this.form.broadcastTitle,
                target_segment_uuid: this.form.selectedAudience,
                scheduled_time: _date + " " + _time,
                visibility: this.form.broadcastVisibility,
                sms: this.form.smsEnabled,
                sms_message: this.form.smsDescription,
                email: this.form.emailEnabled,
                email_subject: this.form.subject,
                email_message: this.form.message,
                push: this.form.pushNotifEnabled,
                push_campaign_name: this.form.campaignName,
                push_message: this.form.pushNotifDescription,
                android: hasAndroid,
                ios: hasIos
            };
            let _event = this.creating
                ? "engagementBroadcasting/createBroadcast"
                : "engagementBroadcasting/updateBroadcast";

            let _this = this;
            this.$store.dispatch(_event, data).then(function() {
                if (_this.errors == null) {
                    _this.hideModal(modal);
                }
            });
        },
        async newBroadcast(modal) {
            await this.initForm();
            await this.$store.commit("engagementBroadcasting/errors", null);
            this.title = "Send New Broadcast";
            await this.$store.commit(
                "engagementBroadcasting/activeBroadcastUuid",
                null
            );
            await this.$store.commit("engagementBroadcasting/creating", true);
            this.form.selectedAudience = "default";
            await this.showModal(modal);
        },
        async editBroadcast(modal, uuid) {
            this.title = "Edit Broadcast";
            await this.$store.commit(
                "engagementBroadcasting/activeBroadcastUuid",
                uuid
            );
            await this.$store.commit("engagementBroadcasting/creating", false);
            let _this = this;
            this.form.selectedDeviceType = [];
            // this.initForm();
            this.form.scheduledTime = {};
            this.$store
                .dispatch("engagementBroadcasting/viewBroadcast")
                .then(response => {
                    let types = JSON.parse(response.type);
                    let payload = JSON.parse(response.payload);
                    //Broadcast Details
                    this.form.broadcastTitle = response.title;
                    this.form.smsEnabled = _this.isExist(types, SMS);
                    this.form.pushNotifEnabled = _this.isExist(types, PUSH);
                    this.form.emailEnabled = _this.isExist(types, EMAIL);
                    //Audience
                    this.form.selectedAudience = response.target_segment_uuid;
                    //SMS Details
                    this.form.smsDescription = payload.sms.message;
                    //Push Notification Details
                    this.form.pushNotifDescription = payload.push.message;
                    this.form.campaignName = payload.push.campaign_name;
                    if (payload.push.device.android === true) {
                        this.form.selectedDeviceType.push("android");
                    }
                    if (payload.push.device.ios === true) {
                        this.form.selectedDeviceType.push("ios");
                    }
                    //EMAIL Details
                    this.form.message = payload.email.message;
                    this.form.subject = payload.email.subject;
                    //Visibility
                    this.form.broadcastVisibility = response.visibility;
                    //Scheduled Time
                    let scheduledDateTime = response.scheduled_time.split(" ");
                    let scheduledDate = scheduledDateTime[0];
                    let scheduledTime = scheduledDateTime[1].split(":");
                    this.form.scheduledDate = new Date(scheduledDate);
                    let _time = {
                        HH: scheduledTime[0],
                        mm: scheduledTime[1],
                        ss: scheduledTime[2]
                    };
                    this.form.scheduledTime = _time;
                });
            await this.showModal(modal);
        },
        isExist(types, type) {
            let response = _.findIndex(types, o => {
                return o === type;
            });
            return response !== -1;
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors.errors[field];
        },
        searchOption(value) {
            this.selectedSearchOption = [value];
            if (this.searchString.trim() !== "") {
                this.search();
            }
        },
        async getTargetSegmentOptions() {
            await this.$store.dispatch(
                "engagementBroadcasting/getTargetSegmentOptions"
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.icon-clear {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: text-bottom;
    background: transparent url("../../assets/images/actions/clear.svg")
        no-repeat center / 20px;
}
.checkbox-group {
    font-family: MainFontRegular, sans-serif;
    font-size: 13px;
    color: #2a2a2a;
}
.search-btn-wrapper {
    text-align: center;
    button {
        font-family: MainFontRegular, sans-serif;
        font-size: 12px;
    }
}
</style>
